import { Box } from "@chakra-ui/react";
import React from "react";

const Section = ({ children, props }) => (
    <Box py="10" px="5" my="5" {...props}>
        <Box maxW="1200px" mx="auto">
            {children}
        </Box>
    </Box>
);

export default Section;